import awsconfig from './aws-exports';
export default awsconfig;
